import { BaseDto } from './base.dto';

export class MerchantCuisineDto extends BaseDto {
  cuisineId: number;
  merchantId: number;
}
